import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient, HttpRequest } from "@angular/common/http";
import { AuthService } from "./auth.service";
import { Globals } from '../globals';
import { map, catchError } from "rxjs/operators";
import { ConfigurationsService } from 'src/app/Service/configurations.service';


@Injectable({
    providedIn: 'root'
})

export class MQTTOperation {
    private httpHeader = new HttpHeaders();

    constructor(private http: HttpClient, private _global: Globals,private configService: ConfigurationsService) {

        this.httpHeader.append('Access-Control-Allow-Origin', '*');
    }

    // Method is used for Publish Message by MQTT
    PublishdatabyMQTT(ReqObj: any) {
        let serviceCallURL: string = this.configService.serviceUrl('ServiceURL') + 'MQTTConnection' + '/PublishdatabyMQTT';
        return this.http.post(serviceCallURL, ReqObj)
            .pipe( map((resp: any) =>  resp.Response),        
                catchError(this._global.handleError)
            );
            
    }
}